module.exports = __webpack_public_path__ + "static/media/hardlopen-voor-bedrijven-white.ab5406dc.svg";